const mutations = {
  confirmCancelHome(state, confirmCancelHome) {
    state.confirmCancelHome = confirmCancelHome
  },
  deleteIndexHome(state, deleteIndexHome) {
    state.deleteIndexHome = deleteIndexHome
  },
  deleteLabelHome(state, deleteLabelHome) {
    state.deleteLabelHome = deleteLabelHome
  },
  denyDeleteHome(state, denyDeleteHome) {
    state.denyDeleteHome = denyDeleteHome
  },
  formHome(state, formHome) {
    state.formHome = formHome
  },
  isModalVisibleHome(state, isModalVisibleHome) {
    state.isModalVisibleHome = isModalVisibleHome
  },
  isValidHomeForm(state, isValidHomeForm) {
    state.isValidHomeForm = isValidHomeForm
  },
  promptDeleteHome(state, promptDeleteHome) {
    state.promptDeleteHome = promptDeleteHome
  },
}

export default mutations
